$(function(){
  $("a[href^=http]:not([href*='" + location.hostname + "'])").attr("target", "_blank");
  
   // #で始まるアンカーをクリックした場合に処理
   $(document).on( "click", 'a[href^="#"]', function() {
    var headerH = $('header').outerHeight();
    var position;
    if(!$(this).hasClass('noSmooth')){
      // スクロールの速度
      var speed = 1000; // ミリ秒
      // アンカーの値取得
      var href= $(this).attr("href");
      // 移動先を取得
      var target = $(href === "#" || href === "" ? 'html' : href);
      // 移動先を数値で取得 
      position = target.offset().top - headerH;
      // スムーススクロール
      $('body,html').animate({scrollTop:position}, speed, 'easeOutCubic');
      return false;
    }
   });
});
$(window).on('load', function() {
  var url = $(location).attr('href');
  var headerH = $('header').outerHeight();
  if(url.indexOf("#") !== -1){
    var id = url.split("#");
    var $target = $('#' + id[id.length - 1]);
    if($target.length){
      var pos = $target.offset().top - headerH;
      $("html, body").animate({scrollTop:pos}, 0, 'easeOutCubic');
    }
  }
});